import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 bg-white" data-testid="page-404">
      <div className="text-center">
        <div className="font-heading text-7xl font-bold text-[#0A1628]">404</div>
        <h1 className="font-heading mt-4 text-2xl sm:text-3xl font-bold text-[#0A1628]">
          الصفحة غير موجودة
        </h1>
        <p className="mt-2 text-slate-600">قد تكون الصفحة نُقلت أو حُذفت.</p>
        <Link to="/" className="mt-8 inline-block aman-btn-light">العودة إلى الرئيسية</Link>
      </div>
    </section>
  );
}
